<!-- 推荐页 -->
<template>
    <div class="container-bg1">
        <!-- ========== 顶部：彩种 Tabs + 搜索按钮 ========== -->
        <van-sticky>
            <div class="tabs-header">
                <van-tabs v-model="lotteryId" @change="onTabLotteryChange" class="lottery-tabs">
                    <van-tab v-for="item in lotteryList" :key="item.value" :title="item.text" :name="item.value" />
                </van-tabs>
                <van-icon name="search" size="20" color="#1989fa" class="search-icon" @click="openSearch" />
            </div>

            <!-- 专区 Tabs -->
            <van-tabs v-show="showPannel" v-model="areaId" @change="onTabAreaChange" class="area-tabs">
                <van-tab v-for="item in areaList" :key="item.value" :title="item.text" :name="item.value" />
            </van-tabs>

            <!-- 下拉菜单：玩法 + 排序 + 期数 -->
            <van-dropdown-menu v-show="showPannel" class="two-row-dropdown">
                <van-dropdown-item ref="playtypeDropdown" v-model="playtypeId" :title="selectedPlaytypeName || '玩法'"
                    title-class="dropdown-title-custom">
                    <template #default>
                        <div class="custom-dropdown-content">
                            <div v-for="group in groupList" :key="group.id" class="group-section">
                                <div class="group-title">{{ group.name }}</div>
                                <div class="group-options">
                                    <span v-for="playtype in group.playtypeList" :key="playtype.id" class="playtype-tag"
                                        :class="{ 'active': playtypeId === playtype.id }"
                                        @click="selectPlaytype(playtype.id)">
                                        {{ playtype.name }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </template>
                </van-dropdown-item>

                <van-dropdown-item v-model="days" :options="daysList" @change="onFilterChange" />
            </van-dropdown-menu>
            <!-- 统计头部 -->
            <div class="list-header">
                <span class="list-header-title">共 <em>{{ total }}</em> 条帖子</span>
                <span class="list-header-sub" @click="togglePannel">{{ toggleName }}</span>
            </div>
        </van-sticky>

        <!-- ========== 下拉刷新 + 上拉加载 ========== -->
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" pulling-text="下拉刷新"
            loosing-text="释放刷新" loading-text="加载中..." style="min-height: 100vh;">
            <van-list v-model="loading" :finished="finished" finished-text="— 已经到底了 —" error-text="加载失败，点击重试"
                loading-text="加载中..." @load="onLoad" :immediate-check="false" offset="50">
                <!-- ========== 列表区 ========== -->
                <div class="case-list">
                    <!-- 遍历item -->
                    <div v-for="item in listData" class="case-item" :key="item.id"
                        @click="toDetail(item.id, playtypeId)">
                        <!-- 专家行 -->
                        <van-row type="flex" justify="space-between" class="item-row">
                            <van-col span="11" class="col-center">
                                <van-image class="head-img" round fit="cover" width="24" height="24"
                                    :src="'/img/headImg/' + item.headImg" />
                                <div style="width: 120px;" class="van-ellipsis font1">
                                    {{ item.nickName }}
                                </div>
                            </van-col>
                            <van-col span="13" class="col-center algin-right">
                                <van-tag v-if="item.upIssueWinResult !== ''" plain type="danger">上期预测 ▪ 中{{
                                    item.upIssueWinResult | commaFilter }}</van-tag>
                            </van-col>
                        </van-row>
                        <!-- 内容行 -->
                        <van-row type="flex" justify="space-between" class="item-content">
                            <van-col span="22" style="line-height: 22px;">
                                {{ item | titleFilter }}
                            </van-col>
                            <van-col offset="1" span="1" style="line-height: 100%;">
                                <van-icon name="arrow" color="#ccc" />
                            </van-col>
                        </van-row>
                        <!-- 底部行 -->
                        <van-row type="flex" justify="space-between" class="item-row">
                            <van-col span="18" class="col-center count-down font2 text-muted">
                                <template v-if="!isEndFilter(item.endTime)">
                                    倒计时
                                    <van-count-down class="time color-red" :time="item.endTime | countDownFilter" />
                                </template>
                                <template v-else>销售截止</template>
                            </van-col>
                            <van-col span="6" class="col-center algin-right money">
                                <div v-if="item.requiredAmount > 0" class="color-red">{{ item.requiredAmount }} 🪙</div>
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </van-list>
        </van-pull-refresh>

        <!-- ========== 全屏搜索页面 ========== -->
        <transition name="slide-up">
            <div v-if="showSearch" class="search-page" @touchmove.prevent>
                <!-- 搜索头部 -->
                <div class="search-header">
                    <van-search v-model="searchKeyword" shape="round" background="#4fc08d" placeholder="搜索专家昵称"
                        :show-action="false" autofocus @search="onSearch" @input="onSearchInput" ref="searchInput" />
                    <span class="search-cancel" @click="closeSearch">取消</span>
                </div>

                <!-- 搜索历史（可选） -->
                <div class="search-history" v-if="!searchKeyword && searchHistory.length > 0">
                    <div class="history-header">
                        <span class="history-title">搜索历史</span>
                        <span class="history-clear" @click="clearHistory">清空</span>
                    </div>
                    <div class="history-tags">
                        <span class="history-tag" v-for="(keyword, index) in searchHistory" :key="index"
                            @click="searchKeyword = keyword; onSearch()">
                            {{ keyword }}
                        </span>
                    </div>
                </div>

                <!-- 搜索结果 -->
                <div class="search-results" v-if="searchKeyword">
                    <div class="result-stats" v-if="searchResults.length > 0">
                        找到 <em>{{ searchResults.length }}</em> 位专家
                    </div>
                    <div class="result-stats empty" v-else>
                        没有找到匹配的专家
                    </div>

                    <!-- 搜索结果列表 -->
                    <div class="result-list">



                        <div v-for="item in searchResults" class="result-item" :key="item.id"
                            @click="toDetail(item.id, playtypeId)">
                            <!-- 专家行 -->
                            <van-row type="flex" justify="space-between" class="item-row">
                                <van-col span="11" class="col-center">
                                    <van-image class="head-img" round fit="cover" width="24" height="24"
                                        :src="'/img/headImg/' + item.headImg" />
                                    <div style="width: 120px;" class="van-ellipsis font1" v-html="item.matchText"></div>
                                </van-col>
                                <van-col span="13" class="col-center algin-right">
                                    <van-tag v-if="item.upIssueWinResult !== ''" plain type="danger">上期预测 ▪ 中{{
                                        item.upIssueWinResult | commaFilter }}</van-tag>
                                </van-col>
                            </van-row>
                            <!-- 内容行 -->
                            <van-row type="flex" justify="space-between" class="item-content">
                                <van-col span="22" style="line-height: 22px;">
                                    {{ item | titleFilter }}
                                </van-col>
                                <van-col offset="1" span="1" style="line-height: 100%;">
                                    <van-icon name="arrow" color="#ccc" />
                                </van-col>
                            </van-row>
                            <!-- 底部行 -->
                            <van-row type="flex" justify="space-between" class="item-row">
                                <van-col span="18" class="col-center count-down font2 text-muted">
                                    <template v-if="!isEndFilter(item.endTime)">
                                        倒计时
                                        <van-count-down class="time color-red" :time="item.endTime | countDownFilter" />
                                    </template>
                                    <template v-else>销售截止</template>
                                </van-col>
                                <van-col span="6" class="col-center algin-right money">
                                    <div v-if="item.requiredAmount > 0" class="color-red">{{ item.requiredAmount }} 🪙
                                    </div>
                                </van-col>
                            </van-row>
                        </div>



                        <!-- <div class="result-item" v-for="item in searchResults" :key="item.id"
                            @click="selectExpert(item)">
                            <van-image class="result-avatar" round fit="cover" width="44" height="44"
                                :src="'/img/headImg/' + item.headImg" />
                            <div class="result-info">
                                <div class="result-match" v-if="item.matchText" v-html="item.matchText">
                                </div>
                            </div>
                            <van-icon name="arrow" class="result-arrow" />
                        </div> -->
                    </div>
                </div>

                <!-- 空状态提示（没有搜索关键词时） -->
                <div class="search-empty" v-if="!searchKeyword">
                    <van-icon name="search" size="48" color="#c8c9cc" />
                    <p>输入专家昵称进行搜索</p>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { home } from '@/api';
import { Toast } from 'vant';
import dayjs from 'dayjs';

export default {
    name: 'Recommend',
    data() {
        return {
            showPannel: true,// 是否展开顶部区
            toggleName: '- 收折筛选区',
            // ===== 筛选条件 =====
            lotteryId: 1,
            areaId: 1,
            playtypeId: 0,
            days: 10,

            // ===== 列表数据 =====
            listData: [],
            total: 0,
            pageNum: 1,
            pageSize: 10,

            // ===== 加载状态 =====
            loading: false,
            finished: false,
            refreshing: false,
            isloading: false,

            // ===== 下拉选项 =====
            lotteryList: [
                { text: '福彩3D', value: 1 },
                { text: '排列三', value: 2 },
            ],
            areaList: [
                { text: '单挑专区', value: 1 },
                { text: '大底专区', value: 2 },
                { text: '综合专区', value: 3 },
                { text: '条件专区', value: 4 },
                { text: '免费专区', value: 5 },
            ],
            groupList: [],
            daysList: [
                { text: '近10期', value: 10 },
                { text: '近20期', value: 20 },
                { text: '近30期', value: 30 },
                { text: '近50期', value: 50 },
                { text: '近100期', value: 100 },
            ],

            // ===== 搜索相关 =====
            showSearch: false,
            searchKeyword: '',
            searchResults: [],
            searchHistory: [],
        };
    },
    computed: {
        selectedPlaytypeName() {
            if (!this.groupList || this.groupList.length === 0) return ''
            for (const group of this.groupList) {
                for (const item of group.playtypeList) {
                    if (item.id === this.playtypeId) {
                        return item.name
                    }
                }
            }
            return ''
        }
    },
    filters: {
        // 如果没有标题，就以彩种名和期号为标题
        titleFilter(v) {
            if (v.title.trim() !== '') return v.title
            return v.nickName + v.lotteryName + '第' + v.issue + '期'
        },
        // 去掉逗号
        commaFilter(v) {
            return v.replace(/,/g, ' ')
        },
        // 倒计时秒数
        countDownFilter(v) {
            return dayjs(v).valueOf() - Date.now()
        },
    },
    async created() {
        if (this.$route.query.areaId) {
            this.areaId = Number(this.$route.query.areaId)
        }
        await this.getPlaytypeList()
        this.loadSearchHistory()
    },
    methods: {
        // 查看帖子
        toDetail(id, playtypeId) {
            this.$router.push({
                path: '/detail',
                query: { id, playtypeId }
            })
        },

        // 收折筛选区
        togglePannel() {
            if (this.showPannel) {
                this.showPannel = false
                this.toggleName = '+ 展开筛选区'
            } else {
                this.showPannel = true
                this.toggleName = '- 收折筛选区'
            }
        },

        // 判断是否截止
        isEndFilter(v) {
            return dayjs(v).valueOf() <= Date.now()
        },

        // ========== 数据加载 ==========
        async loadData() {
            // ✅ 如果 playtypeId 为 0 或 undefined，说明玩法还没加载完成，不执行
            if (this.playtypeId === 0 || this.playtypeId === undefined) {
                console.log('⏸️ playtypeId 未就绪，跳过 loadData')
                return
            }

            if (this.isloading || this.finished) return
            this.isloading = true
            try {
                const params = {
                    lotteryId: this.lotteryId,
                    areaId: this.areaId,
                    playtypeId: this.playtypeId,
                    days: this.days,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                }
                const res = await home.getPostList(params)

                const list = res?.pageInfo?.list || []
                const total = res?.pageInfo?.total || 0

                this.listData = [...this.listData, ...list]
                this.total = total

                if (this.listData.length >= total || list.length < this.pageSize) {
                    this.finished = true
                } else {
                    this.pageNum += 1
                }

            } catch (error) {
                console.error('加载失败:', error)
                Toast.fail('加载失败')
            } finally {
                this.loading = false
                this.isloading = false
            }
        },

        // ========== 上拉加载更多 ==========
        onLoad() {
            if (this.refreshing) {
                this.loading = false
                return
            }
            this.loadData()
        },

        // ========== 下拉刷新 ==========
        async onRefresh() {
            try {
                if (this.isloading) return
                this.isloading = true

                this.pageNum = 1
                this.finished = false
                this.listData = []

                const params = {
                    lotteryId: this.lotteryId,
                    areaId: this.areaId,
                    playtypeId: this.playtypeId,
                    days: this.days,
                    pageNum: 1,
                    pageSize: this.pageSize
                }
                const res = await home.getPostList(params)

                const list = res?.pageInfo?.list || []
                const total = res?.pageInfo?.total || 0

                this.listData = list
                this.total = total

                if (this.listData.length >= total || list.length < this.pageSize) {
                    this.finished = true
                } else {
                    this.pageNum = 2
                }

                Toast.success('刷新成功')

            } catch (error) {
                console.error('刷新失败:', error)
                Toast.fail('刷新失败')
            } finally {
                this.refreshing = false
                this.loading = false
                this.isloading = false
            }
        },

        // ========== 彩种 Tab 切换 ==========
        onTabLotteryChange(value) {
            this.playtypeId = 0
            this.lotteryId = value
            // 切换彩种时重新加载玩法列表
            this.getPlaytypeList()
                .then(() => {
                    this.onFilterChange()
                })
        },

        // ========== 专区 Tab 切换 ==========
        onTabAreaChange(value) {
            this.playtypeId = 0
            this.areaId = value
            // 切换专区时重新加载玩法列表
            this.getPlaytypeList()
                .then(() => {
                    this.onFilterChange()
                })
        },

        // ========== 筛选条件变化 ==========
        onFilterChange() {
            this.pageNum = 1
            this.finished = false
            this.listData = []
            this.total = 0
            this.loadData()
        },

        // ========== 选择玩法 ==========
        selectPlaytype(id) {
            this.playtypeId = id
            this.$refs.playtypeDropdown.toggle()
            this.onFilterChange()
        },

        // ========== 查询玩法列表 ==========
        async getPlaytypeList() {
            try {
                this.groupList = []
                const list = await home.getPlaytypeList(this.lotteryId, this.areaId)
                this.groupList = Array.isArray(list) ? list : []
                if (this.groupList.length > 0 && this.groupList[0].playtypeList.length > 0) {
                    this.playtypeId = this.groupList[0].playtypeList[0].id
                } else {
                    this.playtypeId = 0
                }

                await this.loadData()
            } catch (error) {
                console.error('获取玩法列表失败:', error)
            }
        },

        // ========== 排名样式 ==========
        getRankClass(index) {
            if (index === 0) return 'rank-gold'
            if (index === 1) return 'rank-silver'
            if (index === 2) return 'rank-bronze'
            return 'rank-normal'
        },

        // ==========================================
        // ========== 搜索相关方法 ==========
        // ==========================================

        openSearch() {
            this.showSearch = true
            this.searchKeyword = ''
            this.searchResults = []
            this.$nextTick(() => {
                if (this.$refs.searchInput) {
                    this.$refs.searchInput.focus()
                }
            })
        },

        closeSearch() {
            this.showSearch = false
            this.searchKeyword = ''
            this.searchResults = []
        },

        onSearchInput() {
            if (this.searchKeyword.trim()) {
                this.doSearch(this.searchKeyword)
            } else {
                this.searchResults = []
            }
        },

        onSearch() {
            const keyword = this.searchKeyword.trim()
            if (!keyword) {
                Toast('请输入搜索关键词')
                return
            }
            this.saveSearchHistory(keyword)
            this.doSearch(keyword)
        },

        doSearch(keyword) {
            if (!keyword) {
                this.searchResults = []
                return
            }
            const lowerKeyword = keyword.toLowerCase()
            this.searchResults = this.listData
                .filter(item => {
                    const nickName = (item.nickName || '').toLowerCase()
                    return nickName.includes(lowerKeyword)
                })
                .map(item => ({
                    ...item,
                    matchText: this.highlightMatch(item.nickName, keyword)
                }))
        },

        highlightMatch(text, keyword) {
            if (!text) return ''
            const regex = new RegExp(`(${keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi')
            return text.replace(regex, '<em class="highlight">$1</em>')
        },

        selectExpert(item) {
            console.log('选择了专家:', item)
            this.closeSearch()
            this.toDetail(item.id)
            // Toast(`选择了 ${item.nickName}`)
        },

        loadSearchHistory() {
            try {
                const history = localStorage.getItem('searchHistory')
                if (history) {
                    this.searchHistory = JSON.parse(history).slice(0, 10)
                }
            } catch (e) {
                this.searchHistory = []
            }
        },

        saveSearchHistory(keyword) {
            if (!keyword) return
            let history = this.searchHistory.filter(item => item !== keyword)
            history.unshift(keyword)
            if (history.length > 10) {
                history = history.slice(0, 10)
            }
            this.searchHistory = history
            try {
                localStorage.setItem('searchHistory', JSON.stringify(history))
            } catch (e) { }
        },

        clearHistory() {
            this.searchHistory = []
            try {
                localStorage.removeItem('searchHistory')
            } catch (e) { }
        }
    }
}
</script>

<style scoped>
/* ========================================== */
/* ========== 顶部 Tabs 布局 ========== */
/* ========================================== */
::v-deep .van-tabs__nav {
    background: linear-gradient(to bottom, #FEECEB -44px,
            #F3F3F3 100vh);
}

.tabs-header {
    display: flex;
    align-items: center;
    /* padding-right: 12px; */
    border-bottom: 1px solid #f0f0f0;
    background: linear-gradient(to bottom, #FEECEB -44px,
            #F3F3F3 100vh);
}

.lottery-tabs {
    flex: 1;
}

.lottery-tabs ::v-deep .van-tabs__wrap {
    border: none;
}

.lottery-tabs ::v-deep .van-tabs__nav {
    padding: 0 0 0 12px;
}

.lottery-tabs ::v-deep .van-tab {
    font-size: 15px;
    font-weight: 500;
    padding: 0 16px;
}

.lottery-tabs ::v-deep .van-tab--active {
    color: #ee0a24;
}

/* .lottery-tabs ::v-deep .van-tabs__line {
    background-color: #1989fa;
    bottom: 0;
    height: 3px;
} */

.search-icon {
    flex-shrink: 0;
    color: #333;
    cursor: pointer;
    padding: 8px 16px 8px 8px;
}

.search-icon:active {
    opacity: 0.6;
}

/* 专区 Tabs */
.area-tabs {
    background: #fff;
}

.area-tabs ::v-deep .van-tabs__wrap {
    border: none;
}

.area-tabs ::v-deep .van-tabs__nav {
    padding: 0 12px;
}

.area-tabs ::v-deep .van-tab {
    font-size: 13px;
    padding: 0 7px;
    color: #666;
}

.area-tabs ::v-deep .van-tab--active {
    color: #ee0a24;
}

.area-tabs111 ::v-deep .van-tabs__line {
    /* background-color: #1989fa;
    bottom: 0;
    height: 3px; */

    bottom: 0;
    height: 4px;
    border-radius: 50% 50% 0 0 / 100% 100% 0 0;
    background: linear-gradient(90deg, #ee0a24, #ff6b6b);
    /* 渐变颜色 */
}

::v-deep .van-tabs__line {
    bottom: 0;
    height: 6px;
    border-radius: 0 0 50% 50% / 0 0 200% 200%;
    background: #ee0a24;
    width: 30px;
    /* 控制弧形的宽度 */
    transform: translateX(-50%);
}





.area-tabs::v-deep .van-tabs__nav.van-tabs__nav--line {
    background: #EFEFEF;
}

/* ========================================== */
/* ========== 分组下拉 ========== */
/* ========================================== */

.custom-dropdown-content {
    background: #fff;
    padding: 0 0 12px 0;
    max-height: 400px;
    overflow-y: auto;
}

.group-title {
    padding: 8px 16px;
    font-size: 13px;
    color: #969799;
    background: #f7f8fa;
    font-weight: 500;
}

.group-options {
    display: flex;
    flex-wrap: wrap;
    padding: 8px 12px;
    gap: 8px;
}

.playtype-tag {
    padding: 4px 12px;
    font-size: 13px;
    color: #323233;
    background: #f7f8fa;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid transparent;
}

.playtype-tag:active {
    background: #e8e8e8;
}

.playtype-tag.active {
    color: #1989fa;
    background: #ecf5ff;
    border-color: #1989fa;
}

/* 隐藏默认列表 */
.van-dropdown-item .van-dropdown-item__option {
    display: none !important;
}

/* ========================================== */
/* ========== 列表区 ========== */
/* ========================================== */

.case-list {
    padding: 16px;
}

/* 列表头部 */
.list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px 16px 16px;
    background: #f5f6fa;
    /* background: linear-gradient(to bottom, #FEECEB -44px,
            #F3F3F3 100vh); */
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.list-header-title {
    font-size: 14px;
    color: #666;
}

.list-header-title em {
    font-style: normal;
    color: #1989fa;
    font-weight: 600;
}

.list-header-sub {
    font-size: 12px;
    color: #b8b8b8;
}

/* ========================================== */
/* ========== 卡片 ========== */
/* ========================================== */

.case-item {
    position: relative;
    padding: 8px 16px;
    background: #fff;
    border-radius: 12px;
    margin-bottom: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    transition: transform 0.2s, box-shadow 0.2s;
}

.case-item:active {
    transform: scale(0.98);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.case-item.top-three {
    background: linear-gradient(135deg, #fff9f0 0%, #fff5ed 100%);
    border-left: 3px solid #ff9500;
}

/* ========================================== */
/* ========== 排名徽章 ========== */
/* ========================================== */

.rank-badge {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    background: #f0f0f0;
    color: #999;
}

.rank-gold {
    background: linear-gradient(135deg, #ffd700, #f5a623);
    color: #fff;
    box-shadow: 0 2px 8px rgba(255, 215, 0, 0.4);
}

.rank-silver {
    background: linear-gradient(135deg, #e8e8e8, #c0c0c0);
    color: #fff;
    box-shadow: 0 2px 8px rgba(192, 192, 192, 0.4);
}

.rank-bronze {
    background: linear-gradient(135deg, #f5a623, #d4880f);
    color: #fff;
    box-shadow: 0 2px 8px rgba(245, 166, 35, 0.4);
}

.rank-normal {
    background: #f0f0f0;
    color: #999;
}

/* ========================================== */
/* ========== 行布局 ========== */
/* ========================================== */

.item-row {
    height: 36px;
    align-items: center;
}

.item-row1 {
    height: 26px;
    width: 100%;
    align-items: center;
}

.item-row2 {
    height: 24px;
    width: 100%;
    align-items: center;
}

/* ========================================== */
/* ========== 头像 ========== */
/* ========================================== */

.head-img {
    width: 44px;
    height: 44px;
    border: 2px solid #f0f0f0;
}

.verified-badge {
    position: absolute;
    bottom: -2px;
    right: -2px;
    background: #fff;
    border-radius: 50%;
    padding: 1px;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 13px;
}

/* ========================================== */
/* ========== 用户信息 ========== */
/* ========================================== */

.user-name {
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
}

.user-level {
    font-size: 10px;
    color: #fff;
    background: linear-gradient(135deg, #ff9500, #ff6b35);
    padding: 1px 8px;
    border-radius: 10px;
    margin-left: 6px;
}

/* ========================================== */
/* ========== 胜率 ========== */
/* ========================================== */

.win-rate {
    display: inline-flex;
    align-items: baseline;
    background: #fff5f0;
    padding: 2px 10px 2px 8px;
    border-radius: 12px;
}

.win-rate-num {
    font-size: 18px;
    font-weight: 700;
    color: #ee0a24;
    line-height: 1.2;
}

.win-rate-total {
    font-size: 12px;
    color: #999;
    margin: 0 2px;
}

.win-rate-label {
    font-size: 10px;
    color: #ee0a24;
    background: #ffddd7;
    padding: 0 6px;
    border-radius: 8px;
    margin-left: 4px;
}

/* ========================================== */
/* ========== 统计信息 ========== */
/* ========================================== */

.stat-item {
    font-size: 12px;
    color: #888;
}

.stat-value {
    color: #333;
    font-weight: 500;
}

.stat-value.highlight {
    color: #1989fa;
    font-weight: 600;
}

.stat-divider {
    color: #e5e5e5;
    margin: 0 8px;
}

/* ========================================== */
/* ========== 下拉菜单 ========== */
/* ========================================== */

.two-row-dropdown ::v-deep .van-dropdown-menu__bar {
    display: flex;
    flex-wrap: wrap;
    height: auto;
    padding: 4px 0;
    background: #EFEFEF;
    /* background: linear-gradient(to bottom, #FEECEB -44px, #F3F3F3 100vh); */
    box-shadow: none;
}

.two-row-dropdown ::v-deep .van-dropdown-menu__item:nth-child(1),
.two-row-dropdown ::v-deep .van-dropdown-menu__item:nth-child(2),
.two-row-dropdown ::v-deep .van-dropdown-menu__item:nth-child(3) {
    flex: 0 0 50%;
    max-width: 50%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.two-row-dropdown ::v-deep .van-dropdown-menu__item {
    box-sizing: border-box;
    border-right: 1px solid #f0f0f0;
}

.two-row-dropdown ::v-deep .van-dropdown-menu__item:last-child {
    border-right: none;
}

.two-row-dropdown ::v-deep .van-dropdown-menu__title {
    font-size: 13px;
    color: #333;
}

.two-row-dropdown ::v-deep .dropdown-title-custom {
    font-size: 13px;
    color: #333;
}

/* ========================================== */
/* ========== 工具类 ========== */
/* ========================================== */

.col-center {
    display: flex;
    align-items: center;
}

.algin-right {
    justify-content: flex-end;
}

.font1 {
    font-size: 14px;
    color: #1a1a1a;
}

.font3 {
    font-size: 12px;
    color: #888;
}

.lh {
    line-height: 1.4;
}

.content {
    padding-top: 0px;
    padding-left: 5px;
}

/* ========================================== */
/* ========== 下拉菜单箭头样式覆盖 ========== */
/* ========================================== */

::v-deep .van-dropdown-menu__title::after {
    position: absolute;
    top: 50%;
    right: -4px;
    margin-top: -5px;
    border: 3px solid;
    border-color: transparent transparent #666 #666;
    transform: rotate(-45deg);
    opacity: .8;
    content: '';
}

/* ========================================== */
/* ========== 全屏搜索页面样式 ========== */
/* ========================================== */

.search-page {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #f5f6fa;
    z-index: 9999;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
    transform: translateY(100%);
    opacity: 0;
}

.search-header {
    display: flex;
    align-items: center;
    padding: 8px 16px 8px 12px;
    background: #4fc08d;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;
    padding-top: calc(8px + env(safe-area-inset-top));
}

.search-header .van-search {
    flex: 1;
    padding: 0;
}

.search-header .van-search ::v-deep .van-search__content {
    border-radius: 20px;
    background: #f5f6fa;
}

.search-header .van-search ::v-deep .van-search__content .van-field__control {
    font-size: 15px;
}

.search-cancel {
    font-size: 15px;
    color: #333;
    padding-left: 12px;
    flex-shrink: 0;
    cursor: pointer;
}

.search-cancel:active {
    opacity: 0.6;
}

.search-history {
    background: #fff;
    padding: 16px 16px 20px;
    flex-shrink: 0;
}

.history-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.history-title {
    font-size: 14px;
    font-weight: 500;
    color: #333;
}

.history-clear {
    font-size: 13px;
    color: #999;
    cursor: pointer;
}

.history-clear:active {
    opacity: 0.6;
}

.history-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.history-tag {
    padding: 4px 14px;
    font-size: 13px;
    color: #333;
    background: #f5f6fa;
    border-radius: 16px;
    cursor: pointer;
    transition: background 0.2s;
}

.history-tag:active {
    background: #e8e8e8;
}

.result-stats {
    padding: 12px 16px 8px;
    font-size: 13px;
    color: #999;
    flex-shrink: 0;
}

.result-stats em {
    font-style: normal;
    color: #1989fa;
    font-weight: 600;
}

.result-stats.empty {
    text-align: center;
    padding: 40px 0;
    color: #c8c9cc;
    font-size: 14px;
}

.search-results {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.result-list {
    background: #fff;
    border-radius: 12px;
    margin: 0 12px 12px;
    overflow: hidden;
}

/* .result-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f5f6fa;
    cursor: pointer;
    transition: background 0.2s;
} */
.result-item {
    position: relative;
    padding: 8px 16px;
    background: #fff;
    border-bottom: 1px solid #f5f6fa;
    transition: transform 0.2s, box-shadow 0.2s;
}

.result-item:last-child {
    border-bottom: none;
}

.result-item:active {
    background: #f5f6fa;
}

.result-avatar {
    flex-shrink: 0;
    margin-right: 12px;
    border: 2px solid #f0f0f0;
}

.result-info {
    flex: 1;
    min-width: 0;
}

.result-match {
    font-size: 16px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

::v-deep .highlight {
    color: #1989fa;
    font-weight: 600;
    font-style: normal;
}

.result-arrow {
    color: #c8c9cc;
    font-size: 14px;
    flex-shrink: 0;
}

.search-empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #c8c9cc;
}

.search-empty p {
    margin-top: 12px;
    font-size: 14px;
    color: #c8c9cc;
}

.search-results::-webkit-scrollbar {
    width: 0;
    height: 0;
}
</style>